import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { appState } from 'src/app/shared/interfaces/appState.interface';
import { Order, orderStatusConst } from '@shared-logic/orders';
import { User } from '@shared-logic/user/user.interface';
import { DateChecker, } from '@shared-logic/utils';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { areas } from '@shared-logic/user';
import { NAVEGATION } from 'src/app/shared/const/navegation';
import { OrderValidator, resetAllOrders } from 'src/app/shared/order';
import { OrderExchange } from '@shared-logic/orders';
import { OrderExchangeValidator } from 'src/app/shared/order-exchange';
import { ExchangeService } from 'src/app/shared/services/exchange.service';
import { OBJECT_ID_VOID } from 'src/app/shared/const/options';
import { EXCHANGE_STATUS_CONST } from 'src/app/shared/const/exchange-orders';
import { Subscription } from 'rxjs';
import { ATANOR_CODE_SELLER, ATANOR_SELLER_DATA, SELLER_DATA_VOID, SellerData, SYNGENTA_CODE_SELLER, SYNGENTA_SELLER_DATA } from '@shared-logic/subjects';
import { ResponseRequest } from '@shared-logic/shared-models';
import { IntegrationIBMService } from 'src/app/shared/services/integration-ibm.service';


@Component({
  selector: 'dialog-elements-example-dialog',
  templateUrl: './dialog.html',
  styleUrls: ['./dialog.scss', '../modal.scss']
})

export class DialogOrderToBolets implements OnInit, OnDestroy {
  hour: string = '';
  mensaje: string = 'Estás por enviar la orden de';
  moreInfo: string = '';
  isConfirm: boolean = true;

  //Orders
  identificatorOrderEdit: number = -1;
  disabledButton: boolean = true;

  sellerIsExchange: boolean = false;

  private user!: User; //Store of Redux.
  public orders: Order[] = [];
  isComercial: boolean = true;
  order!: Order;
  orderExchange!: OrderExchange;
  isGenerateOrderExchange: boolean = false;

  public buyerCaseCounterpartWithoutMotherContract: number = 0;

  private orderSubscription!: Subscription;
  private orderExchangeSubscription!: Subscription;
  private userSubscription!: Subscription;
  private isCase$!: Subscription;

  constructor(private router: Router, private store: Store<appState>, public date: DateChecker,
    public dialogRef: MatDialogRef<DialogOrderToBolets>, private orderExcV: OrderExchangeValidator,
    private orderV: OrderValidator, private orderExchangeSvc: ExchangeService,
    private IBM: IntegrationIBMService) {
    this.hour = this.date.setHourFormat();
    this.moreInfo = '';
  }

  ngOnInit(): void {
    this.orderSubscription = this.store.select('order').subscribe(orderReducer => {
      this.orders = orderReducer.generateOrders;
      this.order = orderReducer.generateOrder;
      this.identificatorOrderEdit = orderReducer.indexToEdit;
      this.sellerIsExchange = orderReducer.validation.isExchanger;
    })

    this.orderExchangeSubscription = this.store.select('exchange').subscribe(exchange => {
      this.isGenerateOrderExchange = exchange.isGenerateOrderExchange;
      this.orderExchange = exchange.generateOrder;
    })

    this.userSubscription = this.store.select('usuario').subscribe(user => {
      this.user = user;
      this.isComercial = user.area == areas.comercial;
    })

    this.isCase$ = this.store.select('options', 'buyerCounterpartWithoutMotherContract').subscribe(buyer => {
      this.buyerCaseCounterpartWithoutMotherContract = buyer
    })
  }

  ngOnDestroy(): void {
    this.orderSubscription.unsubscribe();
    this.orderExchangeSubscription.unsubscribe();
    this.userSubscription.unsubscribe();
    this.isCase$.unsubscribe();
  }

  generateOrderBackgroundCommodities() {
    let orderToSave: OrderExchange = JSON.parse(JSON.stringify(this.order));
    const sellerData = JSON.parse(JSON.stringify(orderToSave.sellerData)); //Guardamos seller data,
    //Para reemplazarlo por syngenta, que busque las proforms y luego lo volvemos a ingresar.
    orderToSave.message = ' ';
    orderToSave.statusOrder = orderStatusConst.CONTRACT;
    orderToSave.dataOfcreation = this.orderV.getDataOfCreation(this.user);
    orderToSave.quotas = JSON.stringify(this.orderV.getValidQuotas(orderToSave));
    orderToSave.sellerData = this.getSellerData(); //Setea el comprador como vendedor para buscar en las proformas
    orderToSave.exchange = this.orderExcV.getExchangeInitial(orderToSave);
    orderToSave.exchange.buyer = sellerData; //Seteamos el vendedor viejo (no el seteado en la linea de arriba)
    orderToSave.exchange.idMother = OBJECT_ID_VOID;
    orderToSave.exchange.howSell = orderToSave.howSell;
    orderToSave.exchange.status = EXCHANGE_STATUS_CONST.VERIFICAR;

    this.orderExchangeSvc.createOrderExchange(orderToSave).subscribe((res: ResponseRequest) => {
      orderToSave._id = res.data;
      orderToSave.created_at = this.date.getDateInYYYYMMDDformat(new Date());//Borramos el created at porque todavía no lo tenemos
      this.IBM.createContractExchangeSvc(orderToSave, this.user, 1)
    });

    resetAllOrders(this.store);
    const url = "/" + NAVEGATION.ORDER_EXCHANGE;
    this.router.navigate([url]);
    this.dialogRef.close();
  }

  getQuantOfTons(order: Order) {
    return order.tons + ' toneladas.'
  }

  getNameOfSeller() {
    switch (this.buyerCaseCounterpartWithoutMotherContract) {
      case SYNGENTA_CODE_SELLER: return 'Syngenta Agro-AVC';
      case ATANOR_CODE_SELLER: return 'Atanor';
      default: return '';
    }
  }

  getSellerData(): SellerData {
    switch (this.buyerCaseCounterpartWithoutMotherContract) {
      case SYNGENTA_CODE_SELLER: return SYNGENTA_SELLER_DATA;
      case ATANOR_CODE_SELLER: return ATANOR_SELLER_DATA;

      default: return SELLER_DATA_VOID;
    }
  }

}


